var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.label
        ? _c(
            "gg-input-label",
            {
              staticClass: "d-block pb-1"
            },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
      _c(
        "v-autocomplete",
        _vm._g(
          _vm._b(
            {
              staticClass: "gg-input",
              attrs: {
                label: "",
                dense: "",
                outlined: ""
              },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.$scopedSlots, function(_, slot) {
                    return {
                      key: slot,
                      fn: function fn(scope) {
                        return [_vm._t(slot, null, null, scope)]
                      }
                    }
                  })
                ],
                null,
                true
              ),
              model: {
                value: _vm.internalValue,
                callback: function callback($$v) {
                  _vm.internalValue = $$v
                },
                expression: "internalValue"
              }
            },
            "v-autocomplete",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _vm._l(_vm.$slots, function(_, name) {
            return _vm._t(name, null, {
              slot: name
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }